import { getRouteApi } from "@tanstack/react-router";
import type { SiteShell } from "../server/shell";
import { ErrorState } from "./error-state";

const root = getRouteApi("__root__");

/** A page that doesn't exist, inside the site's own header and footer. */
export function RouteNotFound() {
  const shell = root.useLoaderData() as SiteShell | undefined;
  return <ErrorState status={404} creatorName={shell?.creator.name || "Drate"} />;
}

/** A page that failed to load, inside the site's own header and footer. */
export function RouteError() {
  const shell = root.useLoaderData() as SiteShell | undefined;
  return <ErrorState status={500} creatorName={shell?.creator.name || "Drate"} />;
}
